import React from 'react';

const colors = {
    primary: {
        background: '#062042',
        border: '#062042',
        color: '#fff'
    },
    success: {
        background: '#44942c',
        border: '#44942c',
        color: '#fff'
    },
    secondary: {
        background: '#2e160e',
        border: '#2e160e',
        color: '#fff'
    },
    danger: {
        background: '#dc3545',
        border: '#dc3545',
        color: '#fff'
    },
    warning: {
        background: '#d97706',
        border: '#d97706',
        color: '#fff'
    },
    info: {
        background: '#0ea5e9',
        border: '#0ea5e9',
        color: '#fff'
    },
    light: {
        background: '#f8f9fa',
        border: '#444',
        color: '#444'
    },
    dark: {
        background: '#343a40',
        border: '#343a40',
        color: '#fff'
    }
};

export default props => {

    const style = colors[props.type] || colors.primary;

    return (
        <button
            type='button'
            title={props.title}
            onClick={props.event}
            disabled={props.disabled}
            style={{
                visibility: props.visible ? 'visible' : 'collapse',
                width: props.width || 34,
                height: props.small ? 30 : 36,
                minWidth: props.width || 34,
                border: `1px solid ${style.border}`,
                borderRadius: 9,
                background: style.background,
                color: style.color,
                cursor: props.disabled ? 'not-allowed' : 'pointer',
                opacity: props.disabled ? .55 : 1,
                margin: '0 2px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: props.disabled
                    ? 'none'
                    : '0 2px 6px rgba(0,0,0,.14)',
                transition: 'all .18s ease'
            }}
            onMouseEnter={e => {
                if (!props.disabled) {
                    e.currentTarget.style.transform = 'translateY(-1px)';
                    e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,.18)';
                    e.currentTarget.style.filter = 'brightness(1.06)';
                }
            }}
            onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = props.disabled
                    ? 'none'
                    : '0 2px 6px rgba(0,0,0,.14)';
                e.currentTarget.style.filter = 'brightness(1)';
            }}
        >
            <i
                className={props.icon}
                style={{
                    fontSize: props.small ? 12 : 14
                }}
            />
        </button>
    );
};